import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getColor, transparentize } from '@chakra-ui/theme-tools';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['field', 'addon'];
var baseStyle = {
  field: {
    color: 'gray.400',
    width: '100%',
    minWidth: 0,
    outline: 0,
    position: 'relative',
    appearance: 'none',
    fontFamily: 'body',
    transitionProperty: 'common',
    transitionDuration: 'normal'
  }
};
var size = {
  xs: {
    fontSize: 'sm',
    px: 2,
    h: '2.25rem'
  },
  sm: {
    px: 3,
    fontSize: 'md',
    h: '2.5rem'
  },
  md: {
    px: 3.5,
    fontSize: 'md',
    h: '3.125rem'
  },
  lg: {
    fontSize: 'lg',
    px: 4,
    h: '3.75rem'
  }
};
var sizes = {
  lg: {
    field: size.lg,
    addon: size.lg
  },
  md: {
    field: size.md,
    addon: size.md
  },
  sm: {
    field: size.sm,
    addon: size.sm
  },
  xs: {
    field: size.xs,
    addon: size.xs
  }
};
var getDefaults = function getDefaults(props) {
  var fc = props.focusBorderColor,
    ec = props.errorBorderColor;
  return {
    focusBorderColor: fc || 'gray.400',
    errorBorderColor: ec || 'red.400'
  };
};
var variantDefault = function variantDefault(props) {
  var theme = props.theme;
  var _getDefaults = getDefaults(props),
    fc = _getDefaults.focusBorderColor,
    ec = _getDefaults.errorBorderColor;
  return {
    field: {
      border: '1px solid',
      borderColor: 'gray.300',
      bg: 'white',
      fontFamily: 'body',
      color: 'gray.500',
      borderRadius: 'sm',
      _focus: {
        zIndex: 1,
        borderColor: getColor(theme, fc)
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all',
        _focus: {
          borderColor: 'gray.300'
        }
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      },
      _invalid: {
        borderColor: getColor(theme, ec),
        color: 'red.400',
        _focus: {
          boxShadow: "0 0 0 .2rem ".concat(transparentize(ec, 0.25)(theme)),
          borderColor: getColor(theme, ec)
        },
        '&:-internal-autofill-selected': {
          color: 'red.400',
          borderColor: getColor(theme, ec)
        }
      }
    },
    addon: {
      border: '1px solid',
      borderColor: 'gray.300',
      bg: 'gray.100'
    }
  };
};
var variantFloating = function variantFloating(props) {
  return _objectSpread(_objectSpread({}, variantDefault(props)), {}, {
    field: {
      border: 0,
      borderRadius: 'base',
      shadow: 'sm',
      _focus: _objectSpread(_objectSpread({}, variantDefault(props).field._focus), {}, {
        border: 0,
        shadow: '0 1px 2px 0 rgba(63, 62, 75, 0.2), 0 1px 3px 0 rgba(63, 62, 75, 0.1), 0 1px 2px 0 rgba(63, 62, 75, 0.2), 0 1px 3px 0 rgba(63, 62, 75, 0.1)'
      }),
      _invalid: _objectSpread(_objectSpread({}, variantDefault(props).field._invalid), {}, {
        border: '1px'
      })
    }
  });
};
var variantUnstyled = {
  field: {
    bg: 'transparent',
    px: 0,
    height: 'auto',
    _placeholder: {
      color: 'inherit'
    }
  },
  addon: {
    bg: 'transparent',
    px: 0,
    height: 'auto'
  }
};
var variants = {
  "default": variantDefault,
  floating: variantFloating,
  unstyled: variantUnstyled
};
var defaultProps = {
  size: 'md',
  variant: 'default'
};
var Input = {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  variants: variants,
  defaultProps: defaultProps
};
export { Input as default };